// Get the specified key while ignoring key name case
export function getQueryString(key: string, urlParams?:URLSearchParams): string | undefined{

    const lowerCaseKey = key.toLowerCase();
    urlParams = urlParams ?? new URLSearchParams(location.search);

    for(const [keyQueryString, value] of urlParams)
    {
        if (keyQueryString.toLowerCase() === lowerCaseKey)
            return value;
    }
    return;
}